import { UserRole } from '@app/users/dto';

import { CurrentUserDTO } from './dto';
import { AuthParams } from './types';

const matchRoles = (
  requiredRoles?: CurrentUserDTO['custom_roles'],
  userRoles?: UserRole[],
): boolean => {
  if (!requiredRoles?.length) return true;
  if (!userRoles?.length) return false;
  return requiredRoles.some(role => userRoles.includes(role));
};

export const checkAuth = (authParams: AuthParams, currentUser?: CurrentUserDTO) => {
  const normalizedParams = Array.isArray(authParams) ? authParams : [authParams];

  return normalizedParams.some(params => {
    if (params.pageType === 'publicOnly') {
      return currentUser ? false : true;
    }

    const isLoggedIn = !!currentUser?.sub;
    // // email should be confirmed by default for private pages
    // const emailConfirmed = params.emailConfirmed ?? true;
    // const isEmailConfirmationPassed = currentUser?.email_verified === emailConfirmed;
    return isLoggedIn && matchRoles(params.roles, currentUser.custom_roles);
  });
};

/** return new url with extra `callbackUrl` query param */
export const addReturnUrl = (url: string, callbackUrl?: string) => {
  if (!callbackUrl) return url;

  const locationUrl = typeof window !== 'undefined' ? window.location.origin : '';

  const resultUrl = new URL(decodeURIComponent(url), locationUrl ?? '');
  const cleanedCallbackUrl = new URL(decodeURIComponent(callbackUrl), locationUrl);

  cleanedCallbackUrl.searchParams.delete('callbackUrl');
  resultUrl.searchParams.set(
    'callbackUrl',
    encodeURI(cleanedCallbackUrl.pathname + cleanedCallbackUrl.search),
  );

  return resultUrl.pathname + resultUrl.search;
};
